import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const FeaturedStory = ({ story, onReadMore }) => {
  return (
    <div className="relative bg-card rounded-2xl overflow-hidden shadow-lg mb-14">
      <div className="grid lg:grid-cols-2">
        {/* Image */}
        <div className="relative overflow-hidden sm:min-h-[360px]" style={{ minHeight: "240px" }}>
          <img
            src={story?.featuredImage}
            alt={story?.title}
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
            onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />
          <span className="absolute top-5 left-5 bg-amber-400 text-amber-900 text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
            Featured Story
          </span>
        </div>

        {/* Content */}
        <div className="p-8 lg:p-10 flex flex-col justify-center gap-5">
          {/* Author */}
          <div className="flex items-center gap-3">
            <img
              src={story?.traveler?.avatar}
              alt={story?.traveler?.name}
              className="w-12 h-12 rounded-full object-cover flex-shrink-0"
              onError={(e) => { e.target.src = "/assets/images/no_image.png"; }}
            />
            <div>
              <p className="font-semibold text-foreground">{story?.traveler?.name}</p>
              <p className="text-sm text-text-secondary">{story?.traveler?.profession}</p>
              <p className="text-xs text-primary font-medium mt-0.5">
                {story?.trek} · {story?.trekDate}
              </p>
            </div>
          </div>

          {/* Title */}
          <h2 className="font-headline font-bold text-2xl lg:text-3xl text-foreground leading-snug">
            {story?.title}
          </h2>

          {/* Excerpt */}
          <p className="text-text-secondary leading-relaxed line-clamp-4">
            {story?.excerpt}
          </p>

          {/* Meta row */}
          <div className="flex items-center gap-5 text-sm text-text-secondary">
            <span className="flex items-center gap-1.5">
              <Icon name="Clock" size={15} className="text-primary" />
              {story?.readTime}
            </span>
            <span className="flex items-center gap-1.5">
              <Icon name="Eye" size={15} className="text-primary" />
              {story?.views} views
            </span>
            <span className="flex items-center gap-1 ml-auto">
              {[...Array(5)].map((_, i) => (
                <Icon
                  key={i}
                  name="Star"
                  size={14}
                  className={i < story?.rating ? "text-yellow-400" : "text-gray-300"}
                />
              ))}
            </span>
          </div>

          {/* Tags */}
          <div className="flex flex-wrap gap-2">
            {story?.tags?.map((tag, i) => (
              <span
                key={i}
                className="bg-primary/10 text-primary text-xs font-medium px-3 py-1 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>

          <Button
            variant="default"
            size="lg"
            iconName="BookOpen"
            iconPosition="left"
            onClick={() => onReadMore(story)}
            className="btn-conversion w-fit"
          >
            Read Complete Journey
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedStory;
